import { NavLink, Nav, NavItem } from "reactstrap";
import "../../assets/css/approvals/ApprovalNav.css";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import fetchClient from "../../axios/fetch";

const ApprovalNav = ({ content, changeContent }) => {
    const { t } = useTranslation();
    const auth = useSelector((state) => state.auth);
    const [isApprover, setIsApprover] = useState(false);

    useEffect(() => {
        if (auth?.user?.id) {
            fetchClient()
                .get("api/approval/approvers")
                .then((res) => {
                    const approvers = res.data.data;
                    const found = approvers.find(
                        (value) => value.userId === auth.user.id && value.isApprover === true
                    );
                    setIsApprover(!!found);
                });
        }
    }, [auth?.user?.id]);

    const isAdmin = auth.user?.userRole === "admin";

    let visibleTabs = [];
    if (isAdmin && isApprover) {
        visibleTabs = [
            { name: "approval-booking-list", label: t("booking_to_approve") },
            { name: "approval-management", label: t("approver_management") },
            { name: "approval-history", label: t("history") }
        ];
    } else if (isAdmin && !isApprover) {
        visibleTabs = [
            { name: "approval-management", label: t("approver_management") },
            { name: "approval-history", label: t("history") }
        ];
    } else if (!isAdmin && isApprover) {
        visibleTabs = [
            { name: "approval-booking-list", label: t("booking_to_approve") },
            { name: "approval-history", label: t("history") }
        ];
    }

    useEffect(() => {
        if (visibleTabs.length > 0 && !visibleTabs.some(tab => tab.name === content)) {
            changeContent({ target: { name: visibleTabs[0].name } });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isAdmin, isApprover, content, t]);

    if (visibleTabs.length === 0) return null;

    return (
        <Nav className="approval-nav flex-column flex-md-row" justified>
            {visibleTabs.map(tab => (
                <NavItem key={tab.name}>
                    <NavLink
                        href="#"
                        className="d-flex justify-content-center align-items-center"
                        name={tab.name}
                        onClick={changeContent}
                        active={content === tab.name}
                    >
                        {tab.label}
                    </NavLink>
                </NavItem>
            ))}
        </Nav>
    );
};

export default ApprovalNav;